import React from "react";
import manifest from "../../data.json";

type ContentSectionProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLElement>,
  HTMLElement
> & {
  type: string;
  preview: boolean;
};

const ContentSection: React.FC<ContentSectionProps> = ({
  children,
  type,
  preview,
  ...props
}) => {
  return (
    <section
      data-type={type}
      {...props}
      style={
        preview
          ? {
              position: "relative",
              border: "1px dashed #CCCCCC",
              borderRadius: "4px",
              padding: "4px",
            }
          : undefined
      }
    >
      {preview && (
        <div
          className="text-xs text-gray-600"
          style={{
            background: "#CCCCCCA0",
            borderRadius: "9999px",
            position: "absolute",
            top: 0,
            left: "5px",
            transform: "translateY(-50%)",
            padding: "1px 8px",
          }}
        >
          {(manifest as any).types[type]}
        </div>
      )}
      {children}
    </section>
  );
};

export default ContentSection;
